import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import Categories from "./components/Categories";
import Watchlist from "./components/Watchlist";
import Updates from "./components/Updates";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Featured />
        <Categories />
        <Watchlist />
        <Updates />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}

export default Home;